
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type HomeVehicleWidgetPanelRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function HomeVehicleWidgetPanelRT(): TemplateResult<HomeVehicleWidgetPanelRTRootProps> {
    function repeatSelects1(extraFitmentFields, selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n                    ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n                  ');
                }
                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n                  ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n                ');
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return [
                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                            'value': '',
                            'key': 'null-option'
                        }, '\n                  ', _translate(`select_title`), ' ', this.title, '\n                ') : null,
                        this.loading ? _createElement('option', {
                            'key': 'loading-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-popular',
                                'disabled': true,
                                'key': '13741'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-unpopular',
                                'disabled': true,
                                'key': '13744'
                            }, '\n                    ', _translate(`ymm_bar_unpopular`), '\n                  ')
                        ] : null,
                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                    ];
                }
                function scopeShowSelectedValues4() {
                    var showSelectedValues = this.selectedEntries.length;
                    return _createElement('option', {
                        'key': '_current',
                        'value': '_current'
                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                        _translate(`select_title`),
                        ' ',
                        this.title
                    ] : null);
                }
                function repeatEntry5(entry, index) {
                    return _createElement('div', {
                        'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '3844'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '4062'
                    }, entry.hitCount) : null);
                }
                return !extraFitmentFields.includes(this.field) || this.entries.some(e => e.term) ? _createElement('div', {
                    'className': this.extraClassName,
                    'key': '9'
                }, !this.isSearchable ? _createElement('div', {
                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                    'key': '142'
                }, selectsIndex || selectsIndex === 0 ? _createElement('span', {
                    'className': 'index',
                    'key': '310'
                }, selectsIndex + 1) : null, _createElement('select', {
                    'className': 'cm_select_inner-select cm_select__pretty',
                    'onChange': this.onChange,
                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                    'disabled': this.disabled,
                    'aria-label': this.title
                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                            return _createElement('div', { 'className': 'cm_filterInput' });
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                        'aria-label': this.title,
                        'key': '3058'
                    },
                    !this.hideNullOption ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'onClick': () => this.onChange('')
                    }, '\n              ', _translate(`select_title`), ' ', this.title, '\n            ') : null,
                    this.loading ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'disabled': true
                    }, _translate(`select_loading`)) : null,
                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                ]) : null) : null;
            }, { count: undefined })];
    }
    function scopeExtraFitmentFields2() {
        var extraFitmentFields = window.Convermax.config?.extraFitmentFields?.length ? window.Convermax.config.extraFitmentFields : [
            'BodyNumDoors',
            'Engine',
            'LiftHeight'
        ];
        return _createElement.apply(this, [
            'div',
            { 'className': 'cm_vehicle-widget_select-container cmRepeater_selects' },
            _map(this.selects, repeatSelects1.bind(this, extraFitmentFields))
        ]);
    }
    return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__home cm_vehicle-widget__wheel-tire cm_row cm_vehicle-widget__row' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns cmTemplate_active' }, _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, this.name === 'HomeVehicleWidget_tab' ? 'Other Vehicles' : 'Select Your Vehicle'), scopeExtraFitmentFields2.apply(this, []), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('button', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go btn btn--primary',
        'onClick': this.submit,
        'disabled': !this.hasRequiredSelection
    }, this.name === 'HomeVehicleWidget_tab' ? [
        _createElement('svg', {
            'className': 'cm_mobile-hide',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '20',
            'height': '20',
            'viewBox': '0 0 20 20',
            'fill': 'none',
            'key': '69930'
        }, _createElement('g', { 'id': 'arrow-right-02' }, _createElement('path', {
            'id': 'Vector',
            'd': 'M12.5004 5.83363L16.667 10.0004L12.5003 14.167',
            'stroke': 'url(#paint0_linear_5858_3635)',
            'strokeLinecap': 'square',
            'strokeLinejoin': 'round'
        }), _createElement('path', {
            'id': 'Vector_2',
            'd': 'M16.25 10L3.75 10',
            'stroke': 'url(#paint1_linear_5858_3635)',
            'strokeLinecap': 'square',
            'strokeLinejoin': 'round'
        })), _createElement('defs', {}, _createElement('linearGradient', {
            'id': 'paint0_linear_5858_3635',
            'x1': '18.4112',
            'y1': '16.3495',
            'x2': '10.0194',
            'y2': '15.3322',
            'gradientUnits': 'userSpaceOnUse'
        }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
            'offset': '1',
            'stopColor': '#999999'
        })), _createElement('linearGradient', {
            'id': 'paint1_linear_5858_3635',
            'x1': '21.4826',
            'y1': '10.2619',
            'x2': '18.9744',
            'y2': '2.66057',
            'gradientUnits': 'userSpaceOnUse'
        }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
            'offset': '1',
            'stopColor': '#999999'
        })))),
        _createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': '0 0 20 20',
            'fill': 'none',
            'className': 'h-full w-full cm_desktop-hide',
            'key': '69932'
        }, _createElement('path', {
            'd': 'M4.75 10H14.25M14.25 10L10.5 6.25M14.25 10L10.5 13.75',
            'stroke': 'currentColor',
            'strokeWidth': '1.9',
            'strokeLinecap': 'round',
            'strokeLinejoin': 'round'
        }))
    ] : null, this.name !== 'HomeVehicleWidget_tab' ? _translate(`ymm_bar_submit`) : '', '\n        '), _createElement('button', {
        'type': 'button',
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear cm_hide',
        'onClick': this.clear,
        'tabIndex': '-1',
        'aria-hidden': 'true'
    }, [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'className': 'cm_icon cm_icon-reset',
            'height': '16px',
            'viewBox': '0 0 16 16',
            'key': '85650'
        }, _createElement('path', { 'd': 'M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z' }), _createElement('path', { 'd': 'M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z' }))])))));
}
        export const componentNames = ["cm:filterInput"]